import { CalendarIcon, CreditCardIcon, FileIcon, KebabHorizontalIcon, MailIcon, PersonIcon, SyncIcon, TrashIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Checkbox, IconButton, Text as PrimerText } from "@primer/react";
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { mucPhaiThuApi } from "../../api/mucPhaiThuApi";
import { mucPhaiThuChiTietApi } from "../../api/mucPhaiThuChiTietApi";
import { saleSetApi } from "../../api/saleSetApi";
import { thuPhiApi } from "../../api/thuPhiApi";
import CmbHinhThucThanhToan from "../../components/combobox-hinhthucthanhtoan/CmbHinhThucThanhToan";
import DataGrid from "../../components/data-grid";
import FocusedCell from "../../components/data-grid/FocusedCell";
import { IDataGridColumn } from "../../components/data-grid/type/IDataGridProps";
import { HocSinhRender, Infomation } from "../../components/hoc-sinh/HocSinhRender";
import TextInputNumber from "../../components/text-input-number/TextInputNumber";
import ThuPhiChiTiet from "../../components/thu-phi/chi-tiet/ThuPhiChiTiet";
import { HuyChungTuModal } from "../../components/thu-phi/huy-chung-tu";
import Button from "../../components/ui/button";
import DateInput from "../../components/ui/date-input";
import ModalActions from "../../components/ui/modal/ModalActions";
import MyModal from "../../components/ui/modal/MyModal";
import TextWithEllipse from "../../components/ui/text-with-ellipse";
import TextInput from "../../components/ui/text-input";
import { useCommonContext } from "../../contexts/common";
import { showNotify } from "../../helpers/toast";
import { IMucPhaiThuHoanPhiRequest } from "../../models/request/muc-phai-thu/IMucPhaiThuAddHoanPhiRequest";
import { HinhThucThanhToanVm, sf_mucphaithu_viewmodel } from "../../models/response/thu-phi/sf_mucphaithu";
import HoanPhiDaTao from "./hoan-phi-da-tao";

interface IHoanPhiHocSinhPageProps {
    onClose: () => void;
    sf_mucphaithu_id?: number;
    sf_mucphaithu_ids?: number[];
    ts_hocsinh_id?: number;
    nam_hoc?: string;
    isTab?: boolean;
}
const HoanPhiHocSinhPage = (props: IHoanPhiHocSinhPageProps) => {
    const { ts_hocsinh_viewmodel } = useSelector((x: any) => x.hocSinhProfile);
    const [hinhThucNopBomId, setHinhThucNopBomId] = useState<number>(0);
    const [mucPhaiThu, setMucPhaiThu] = useState<any>(); // sf_mucphaithu_viewmodel
    const [mucPhaiThuHoanPhis, setMucPhaiThuHoanPhis] = useState<
        sf_mucphaithu_viewmodel[]
    >([]);
    const [mucPhaiThuChiTiets, setMucPhaiThuChiTiets] = useState<
        any[] // sf_mucphaithu_chitiet_viewmodel
    >([]);
    const [mucPhaiThuChiTietSelectedIds, setMucPhaiThuChiTietSelectedIds] = useState<number[]>([]);
    const [mucPhaiThuMienGiams, setMucPhaiThuMienGiams] = useState([]);
    const [mucPhaiThuChiTietMienGiams, setMucPhaiThuChiTietMienGiams] = useState([]);
    const [ngaythu, set_ngaythu] = useState<any>(moment().format('YYYY-MM-DD'));
    const [noiDungHoanPhi, setNoiDungHoanPhi] = useState<string>('');
    const [existingRVVouchers, setExistingRVVouchers] = useState<any[]>([]);
    const [isLoadingExisting, setIsLoadingExisting] = useState(false);
    const [rvSelected, setRvSelected] = useState<any | null>(null);
    const [isShowRVChiTiet, setIsShowRVChiTiet] = useState(false);
    const [isShowRVHuy, setIsShowRVHuy] = useState(false);
    const [isShowRVEmail, setIsShowRVEmail] = useState(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isShowConfirmCreate, setIsShowConfirmCreate] = useState<boolean>(false);

    const grid = useRef<any>();

    useEffect(() => {
        handleReloadAllAsync();
    }, [props.sf_mucphaithu_id, props.sf_mucphaithu_ids, props.ts_hocsinh_id, props.nam_hoc]);

    const handleReloadExistingRVAsync = async () => {
        if (!props.ts_hocsinh_id) return;
        setIsLoadingExisting(true);
        try {
            const res = await mucPhaiThuApi.select_by_hocsinh({
                ts_hocsinh_id: props.ts_hocsinh_id,
                nam_hoc: props.nam_hoc || ""
            });
            if (res.is_success) {
                const rvs = (res.data || []).filter((x: any) =>
                    x.so_chung_tu && x.so_chung_tu.trim().toUpperCase().startsWith("RV")
                );
                // Sắp xếp theo ngày mới nhất lên đầu
                rvs.sort((a: any, b: any) => moment(b.ngay_thu).valueOf() - moment(a.ngay_thu).valueOf());
                setExistingRVVouchers(rvs);
            }
        } catch (error) {
            console.error("Failed to load existing RVs", error);
        } finally {
            setIsLoadingExisting(false);
        }
    };

    const handleReloadAllAsync = async () => {
        // if (isShowConfirmCreate) return;  // Removed to ensure reload works after closing confirm modal
        handleGetMucPhaiThuInfoAsync();
        handletGetMucPhaiThuChiTietAsync();
        handleGetMucPhaiThuHoanPhiAsync();
        handleGetMucPhaiThuMienGiamAsync();
        handleGetMucPhaiThuChiTietMienGiamAsync();
        handleReloadExistingRVAsync();
    };
    const handleGetMucPhaiThuInfoAsync = async () => {
        if (props.sf_mucphaithu_id && props.sf_mucphaithu_id > 0) {
            const res = await mucPhaiThuApi.selectById(props.sf_mucphaithu_id);
            if (res.is_success) {
                setMucPhaiThu(res.data);
            } else {
                showNotify({ message: "Không tải được chứng từ", type: 'error' });
            }
        } else {
            setMucPhaiThu(undefined);
        }
    };
    const handleGetMucPhaiThuMienGiamAsync = async () => {
        const ids = props.sf_mucphaithu_ids ?? (props.sf_mucphaithu_id ? [props.sf_mucphaithu_id] : []);
        if (ids.length > 0) {
            const allMienGiams: any = [];
            for (const id of ids) {
                const res = await thuPhiApi.select_miengiam(id);
                if (res.is_success) {
                    allMienGiams.push(...res.data);
                }
            }
            setMucPhaiThuMienGiams(allMienGiams);
        } else {
            setMucPhaiThuMienGiams([]);
        }
    };
    const handleGetMucPhaiThuChiTietMienGiamAsync = async () => {
        const ids = props.sf_mucphaithu_ids ?? (props.sf_mucphaithu_id ? [props.sf_mucphaithu_id] : []);
        if (ids.length > 0) {
            const allMienGiamChiTiets: any = [];
            for (const id of ids) {
                const res = await thuPhiApi.select_miengiam_chitiet(id);
                if (res.is_success) {
                    allMienGiamChiTiets.push(...res.data);
                }
            }
            setMucPhaiThuChiTietMienGiams(allMienGiamChiTiets);
        } else {
            setMucPhaiThuChiTietMienGiams([]);
        }
    };
    const handleGetMucPhaiThuHoanPhiAsync = async () => {
        const ids = props.sf_mucphaithu_ids ?? (props.sf_mucphaithu_id ? [props.sf_mucphaithu_id] : []);
        if (ids.length > 0) {
            const allHoanPhis: any = [];
            for (const id of ids) {
                const res = await mucPhaiThuApi.selectByHoanPhiGoc(id);
                if (res.is_success) {
                    allHoanPhis.push(...res.data);
                }
            }
            setMucPhaiThuHoanPhis(allHoanPhis);
        } else {
            setMucPhaiThuHoanPhis([]);
        }
    };
    const prevSelectedIdsRef = useRef<number[]>([]);
    useEffect(() => {
        const added = mucPhaiThuChiTietSelectedIds.filter(id => !prevSelectedIdsRef.current.includes(id));
        const removed = prevSelectedIdsRef.current.filter(id => !mucPhaiThuChiTietSelectedIds.includes(id));

        if (added.length > 0) {
            setMucPhaiThuChiTiets(prev => prev.map(item => {
                if (added.includes(item.id) && item.so_tien_de_hoan === 0) {
                    const balance = (item.so_tien_da_nop || 0) - Math.abs(item.so_tien_hoan_phi || 0);
                    return { ...item, so_tien_de_hoan: balance > 0 ? balance : 0 };
                }
                return item;
            }));
        }

        if (removed.length > 0) {
            setMucPhaiThuChiTiets(prev => prev.map(item => {
                if (removed.includes(item.id) && item.so_tien_de_hoan > 0) {
                    return { ...item, so_tien_de_hoan: 0 };
                }
                return item;
            }));
        }

        prevSelectedIdsRef.current = mucPhaiThuChiTietSelectedIds;
    }, [mucPhaiThuChiTietSelectedIds]);

    const handletGetMucPhaiThuChiTietAsync = async () => {
        let res: any;
        const ids = props.sf_mucphaithu_ids ?? (props.sf_mucphaithu_id ? [props.sf_mucphaithu_id] : []);

        if (ids.length > 0) {
            // Load by specific IDs
            const allItems = [];
            for (const id of ids) {
                const response = await mucPhaiThuChiTietApi.selectByMucPhaiThu(id);
                if (response.is_success) {
                    allItems.push(...response.data);
                }
            }
            res = { is_success: true, data: allItems };
        } else if (props.ts_hocsinh_id && props.nam_hoc) {
            // Reverted to saleSetApi as requested
            res = await saleSetApi.selectByStudent({
                ts_hocsinh_id: props.ts_hocsinh_id,
                nam_hoc: props.nam_hoc
            });
        }

        if (res && res.is_success) {
            const paidItems = (res.data || []).filter((x: any) => (x.so_tien_da_nop || 0) > 0);
            setMucPhaiThuChiTiets(paidItems.map((x: any) => ({
                ...x,
                id: x.id || x.sf_khoannop_id,
                so_tien_de_hoan: 0, // Field for current refund input
                ghi_chu: ""
            })));
            setMucPhaiThuChiTietSelectedIds([]);
        } else {
            showNotify({ message: "Không tải được danh sách khoản thu", type: 'error' });
        }
    };
    const handleUpdateSoTienTruyThu = async ({ sf_mucphaithu_chitiet_id, so_tien_truy_thu }: { sf_mucphaithu_chitiet_id: number; so_tien_truy_thu: number }) => {
        const datasend: { sf_mucphaithu_chitiet_id: number; so_tien_truy_thu: number } = { sf_mucphaithu_chitiet_id, so_tien_truy_thu };
        const res = await mucPhaiThuChiTietApi.UpdateSoTienTruyThu(datasend);
        if (res.is_success) {
            handleReloadAllAsync();
        }
    };
    const { translate } = useCommonContext();
    const [focusedCell, setFocusedCell] = useState<any>();
    const [expandedGroups, setExpandedGroups] = useState<Map<string, string>>(new Map());

    const toggleGroup = useCallback((groupKey: string) => {
        setExpandedGroups((prev) => {
            const newMap = new Map(prev);
            if (newMap.has(groupKey)) {
                newMap.delete(groupKey);
            } else {
                newMap.set(groupKey, groupKey);
            }
            return newMap;
        });
    }, []);

    const hanldeCreateHoanPhiAsync = async () => {
        setIsSaving(true);
        const selectedItems = mucPhaiThuChiTiets.filter((x: any) => {
            return mucPhaiThuChiTietSelectedIds.includes(x.id);
        });
        const totalAmount = selectedItems
            .map((x: any) => x.so_tien_de_hoan)
            .reduce((a: any, b: any) => a + b, 0);
        if (totalAmount <= 0) {
            showNotify({ message: "Số tiền hoàn phí phải lớn hơn 0", type: 'error' });
            setIsSaving(false);
            return false;
        }
        if (noiDungHoanPhi === '') {
            setIsSaving(false);
            showNotify({ message: "Vui lòng nhập nội dung hoàn phí", type: 'error' });
            return;
        }

        const request: IMucPhaiThuHoanPhiRequest = {
            ts_hocsinh_id: props.ts_hocsinh_id || 0,
            nam_hoc: props.nam_hoc || "",
            sf_mucphaithu_id: 0,
            items: selectedItems.map((x: any) => {
                return {
                    sf_khoannop_id: x.sf_khoannop_id,
                    so_tien_hoan_phi: x.so_tien_de_hoan,
                    ghi_chu: x.ghi_chu
                };
            }),
            mien_giams: [],
            ngay_thu: ngaythu,
            noi_dung_hoan_phi: noiDungHoanPhi,
            sf_hinhthucnopbom_ids: hinhThucNopBomId.toString(),
            sf_hinhthucthanhtoan_id: hinhThucNopBomId
        };
        const res = await mucPhaiThuApi.addHoanPhi(request);
        const hasError = !res.is_success;

        setIsSaving(false);
        if (!hasError) {
            showNotify({ message: "Tạo hoàn phí thành công", type: 'success' });
            setIsShowConfirmCreate(false);
            setNoiDungHoanPhi('');
            handleReloadAllAsync();
        } else {
            showNotify({ message: "Có lỗi khi tạo một số khoản hoàn phí", type: 'error' });
            handleReloadAllAsync();
        }
    };
    const formatCurrency = (value: any) => {
        if (value === null || value === undefined) return "";
        if (value === 0) return "0";
        return new Intl.NumberFormat("vi-VN").format(value);
    };

    const calculateGroupSum = (groupItems: any[], field: string) => {
        if (!groupItems) return 0;
        return groupItems.reduce((acc, item) => acc + (item[field] || 0), 0);
    };

    const columns = useMemo<IDataGridColumn[]>(() => {
        return [
            {
                caption: translate("Nhóm khoản nộp"),
                dataField: "ten_khoan_nop_group",
                width: 250,
                fixed: "left",
                cellRender: (data: any) => {
                    if (data.isGroupHeader) return <Box sx={{ fontWeight: "bold", color: "#0969da" }}>{data.ten_khoan_nop_group || "Khác"}</Box>;
                    return <span>{data.ten_khoan_nop_group}</span>;
                }
            },
            {
                caption: translate("Mã khoản nộp"),
                dataField: "ma_khoan_nop",
                width: 130,
                fixed: "left",
                cellRender: (data: any) => {
                    if (data.isGroupHeader) return "";
                    return <span>{data.ma_khoan_nop}</span>;
                }
            },
            {
                caption: translate("Tên khoản nộp"),
                dataField: "ten_khoan_nop",
                width: 200,
                fixed: "left",
                cellRender: (data: any) => {
                    if (data.isGroupHeader) return "";
                    return <span>{data.ten_khoan_nop}</span>;
                }
            },

            {
                caption: translate("Đã nộp"),
                dataField: "so_tien_da_nop",
                width: 120,
                align: "right",
                cellRender: (data: any) => {
                    const val = data.isGroupHeader ? calculateGroupSum(data.groupItems, "so_tien_da_nop") : data.so_tien_da_nop;
                    return <Box sx={{ fontWeight: data.isGroupHeader ? 'bold' : 'normal' }}>{formatCurrency(val)}</Box>;
                }
            },
            {
                caption: translate("Tổng hoàn trả"),
                dataField: "so_tien_hoan_phi",
                width: 120,
                align: "right",
                cellRender: (data: any) => {
                    const val = data.isGroupHeader ? calculateGroupSum(data.groupItems, "so_tien_hoan_phi") : data.so_tien_hoan_phi;
                    if (!val) return "";
                    return <Box sx={{ fontWeight: data.isGroupHeader ? 'bold' : 'normal' }}>{formatCurrency(-Math.abs(val))}</Box>;
                }
            },
            {
                caption: translate("Còn lại"),
                dataField: "con_lai",
                width: 120,
                align: "right",
                cellRender: (data: any) => {
                    if (data.isGroupHeader) {
                        const da_nop = calculateGroupSum(data.groupItems, "so_tien_da_nop");
                        const da_hoan = calculateGroupSum(data.groupItems, "so_tien_hoan_phi");
                        const balance = da_nop - Math.abs(da_hoan);
                        return <Box sx={{ fontWeight: 'bold' }}>{balance <= 0 ? "" : formatCurrency(balance)}</Box>;
                    }
                    const balance = (data.so_tien_da_nop || 0) - Math.abs(data.so_tien_hoan_phi || 0);
                    return <Box>{balance <= 0 ? "" : formatCurrency(balance)}</Box>;
                }
            },
            {
                caption: translate("Hoàn phí"),
                dataField: "so_tien_de_hoan",
                width: 120,
                align: "right",
                isAllowFocus: true,
                cellRender: (data: any) => {
                    const balance = (data.so_tien_da_nop || 0) - Math.abs(data.so_tien_hoan_phi || 0);
                    if (data.isGroupHeader) {
                        return <Box sx={{ fontWeight: 'bold', color: 'accent.fg' }}>{formatCurrency(calculateGroupSum(data.groupItems, "so_tien_de_hoan"))}</Box>;
                    }
                    if (balance <= 0) return <Box sx={{ color: 'fg.muted', textAlign: 'right' }}>-</Box>;

                    const isFocused = focusedCell && focusedCell.dataField === "so_tien_de_hoan" && focusedCell.rowData.id === data.id;
                    const value = data.so_tien_de_hoan;
                    return (
                        <Box>
                            {isFocused ? (
                                <FocusedCell onLostFocused={() => setFocusedCell(undefined)}>
                                    <TextInputNumber
                                        defaultValue={value}
                                        autoFocus
                                        className="text-input-noborder"
                                        isAlignRight
                                        onValueChanged={(val) => {
                                            setMucPhaiThuChiTiets(prev => prev.map(p => p.id === data.id ? { ...p, so_tien_de_hoan: val } : p));

                                            if (val > 0) {
                                                setMucPhaiThuChiTietSelectedIds(prev => {
                                                    if (!prev.includes(data.id)) return [...prev, data.id];
                                                    return prev;
                                                });
                                            } else {
                                                setMucPhaiThuChiTietSelectedIds(prev => prev.filter(id => id !== data.id));
                                            }
                                        }}
                                    />
                                </FocusedCell>
                            ) : (
                                <Box sx={{ fontWeight: 'bold', color: 'accent.fg' }}>{formatCurrency(value)}</Box>
                            )}
                        </Box>
                    );
                }
            },
            {
                caption: translate("Ghi chú"),
                dataField: "ghi_chu",
                width: 250,
                cellRender: (data: any) => {
                    if (data.isGroupHeader) return "";
                    return (
                        <TextInput
                            value={data.ghi_chu || ""}
                            block
                            className="text-input-noborder"
                            onChange={(e: any) => {
                                const val = e.target.value;
                                setMucPhaiThuChiTiets(prev => prev.map(p => p.id === data.id ? { ...p, ghi_chu: val } : p));
                            }}
                        />
                    );
                }
            },
        ];
    }, [focusedCell, translate, mucPhaiThuChiTietMienGiams, props.sf_mucphaithu_id, mucPhaiThuChiTiets]);

    const totalSummary = useMemo(() => {
        return [
            { dataField: "so_tien_da_nop", summaryType: "sum" as const },
            {
                dataField: "so_tien_hoan_phi",
                summaryType: "sum" as const,
                customizeRender: (data: any[], value: any) => {
                    if (!value) return "-";
                    return <Box>{formatCurrency(-Math.abs(value))}</Box>;
                }
            },
            {
                dataField: "con_lai",
                summaryType: "sum" as const,
                customizeRender: (data: any[], value: any) => {
                    const total_da_nop = data.reduce((acc, curr) => acc + (curr.so_tien_da_nop || 0), 0);
                    const total_da_hoan = data.reduce((acc, curr) => acc + (curr.so_tien_hoan_phi || 0), 0);
                    const balance = total_da_nop - total_da_hoan;
                    if (balance <= 0) return "-";
                    return <Box>{formatCurrency(balance)}</Box>;
                }
            },
            { dataField: "so_tien_de_hoan", summaryType: "sum" as const },
        ];
    }, [formatCurrency]);

    const totalHoanPhi = useMemo(() => {
        return mucPhaiThuChiTiets.reduce((acc, curr) => acc + (curr.so_tien_de_hoan || 0), 0);
    }, [mucPhaiThuChiTiets]);

    const rvColumns = useMemo((): IDataGridColumn[] => {
        return [
            {
                id: "cmd",
                caption: "Thao tác",
                width: 90,
                align: "center",
                fixed: "left",
                cellRender: (data: any) => {
                    return (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <ActionMenu>
                                <ActionMenu.Anchor>
                                    <IconButton
                                        icon={KebabHorizontalIcon}
                                        variant="invisible"
                                        size="small"
                                        aria-label="Thao tác"
                                    />
                                </ActionMenu.Anchor>
                                <ActionMenu.Overlay>
                                    <ActionList>
                                        <ActionList.Item onSelect={() => { setRvSelected(data); setIsShowRVChiTiet(true); }}>
                                            <ActionList.LeadingVisual><FileIcon /></ActionList.LeadingVisual>
                                            Chi tiết
                                        </ActionList.Item>
                                        <ActionList.Item variant="danger" onSelect={() => { setRvSelected(data); setIsShowRVHuy(true); }}>
                                            <ActionList.LeadingVisual><TrashIcon /></ActionList.LeadingVisual>
                                            Hủy chứng từ
                                        </ActionList.Item>
                                    </ActionList>
                                </ActionMenu.Overlay>
                            </ActionMenu>
                        </Box>
                    );
                },
            },
            {
                id: "so_chung_tu",
                caption: "Số CT",
                dataField: "so_chung_tu",
                width: 130,
                fixed: "left",
                isMainColumn: true,
                cellRender: (data: any) => (
                    <Box
                        as="button"
                        sx={{
                            cursor: "pointer",
                            color: "#3c22ff",
                            background: "none",
                            border: "none",
                            padding: 0,
                            textDecoration: "underline",
                            fontWeight: 600
                        }}
                        onClick={() => { setRvSelected(data); setIsShowRVChiTiet(true); }}
                    >
                        {data.so_chung_tu}
                    </Box>
                ),
            },

            {
                id: "noi_dung",
                caption: "Nội dung",
                dataField: "noi_dung",
                width: 250,
                cellRender: (data: any) => (
                    <TextWithEllipse text={data.noi_dung || ""} lineNumber={2} />
                ),
            },
            {
                id: "tong_tien_da_nop",
                caption: "Tổng hoàn trả",
                dataField: "tong_tien_da_nop",
                width: 120,
                align: "right",
                cellRender: (data: any) => (
                    <span>
                        {data.tong_tien_da_nop.toLocaleString()}
                    </span>
                ),
            },
            {
                id: "hinh_thuc_thanh_toan",
                caption: "Hình thức thanh toán",
                dataField: "hinh_thuc_thanh_toan",
                width: 200,
                cellRender: (data: any) => {
                    const danhSach = data?.HinhThucThanhToanVms as
                        | HinhThucThanhToanVm[]
                        | undefined;

                    if (!danhSach || danhSach.length === 0) {
                        return <></>;
                    }

                    return (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                            {danhSach.map((item, index) => {
                                if (item.hinh_thuc_thanh_toan === null) {
                                    return null;
                                }

                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            fontSize: 0,
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                color: "accent.fg",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <CreditCardIcon size={14} />
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                flex: 1,
                                                minWidth: 0,
                                            }}
                                        >
                                            <TextWithEllipse
                                                text={item.hinh_thuc_thanh_toan}
                                                lineNumber={1}
                                            />
                                            <Box as="span" sx={{ color: "fg.muted" }}>:</Box>
                                        </Box>
                                        <Box
                                            as="strong"
                                            sx={{
                                                fontWeight: "semibold",
                                                color: "fg.default",
                                                flexShrink: 0,
                                                textAlign: "right",
                                            }}
                                        >
                                            {item.so_tien.toLocaleString()}
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    );
                },
            },
            {
                id: "nguoi_thu_username",
                caption: "Ngày thu",
                dataField: "nguoi_thu_username",
                width: 150,
                cellRender: (data: any) => {
                    const infos: Infomation[] = [
                        {
                            title: "",
                            data: data.nguoi_thu_username,
                            icon: <PersonIcon size={14} />,
                            fontWeight: "500",
                        },
                        {
                            title: "",
                            data:
                                moment(data.ngay_thu_thuc_te).format("DD/MM/YYYY") ===
                                    "01/01/0001"
                                    ? ""
                                    : moment(data.ngay_thu_thuc_te).format(
                                        "DD/MM/YYYY HH:mm"
                                    ),
                            icon: <CalendarIcon size={14} />,
                        },
                    ];
                    return <HocSinhRender infors={infos} />;
                },
            }
        ];
    }, []);

    const TopToolbar = (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 1, p: 2, bg: 'canvas.subtle', borderRadius: 2, border: '1px solid', borderColor: 'border.default', alignItems: 'center' }}>


            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <PrimerText sx={{ fontWeight: 'bold', fontSize: 13 }}>Ngày hoàn trả:</PrimerText>
                <Box sx={{ width: 140 }}>
                    <DateInput
                        value={moment(ngaythu).format('DD/MM/YYYY')}
                        onValueChanged={(value) => {
                            const newNgayThu = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD');
                            if (newNgayThu !== ngaythu) set_ngaythu(newNgayThu);
                        }}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', minWidth: 200 }}>
                <PrimerText sx={{ fontWeight: 'bold', fontSize: 13 }}>Hình thức thanh toán:</PrimerText>
                <Box sx={{ flex: 1, minWidth: 200 }}>
                    <CmbHinhThucThanhToan
                        value={hinhThucNopBomId}
                        dmCoSoId={mucPhaiThu?.dm_coso_id || mucPhaiThuChiTiets[0]?.dm_coso_id || ts_hocsinh_viewmodel?.dm_coso_id}
                        onValueChanged={(id) => setHinhThucNopBomId(id)}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flex: 1 }}>
                <PrimerText sx={{ fontWeight: 'bold', fontSize: 13, whiteSpace: 'nowrap' }}>Ghi chú:</PrimerText>
                <TextInput
                    value={noiDungHoanPhi}
                    onChange={(e: any) => setNoiDungHoanPhi(e.target.value)}
                    sx={{ flex: 1 }}
                    width={200}
                />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <PrimerText sx={{ fontWeight: 'bold', fontSize: 13 }}>Tiền hoàn trả:</PrimerText>
                <Box as="input" readOnly value={formatCurrency(totalHoanPhi)} sx={{ p: '4px 8px', width: 120, border: '1px solid', borderColor: 'border.default', textAlign: 'right', fontWeight: 'bold', color: 'accent.fg', bg: 'canvas.default' }} />
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                    variant="default"
                    onClick={handleReloadAllAsync}
                    leadingVisual={SyncIcon}
                >
                    {translate("Làm mới")}
                </Button>
                <Button
                    variant="primary"
                    onClick={() => setIsShowConfirmCreate(true)}
                    disabled={isSaving || totalHoanPhi <= 0}
                >
                    {`Tạo hoàn phí`}
                </Button>
            </Box>
        </Box>
    );

    const Content = (
        <Box sx={{ p: 1 }}>
            {TopToolbar}

            <DataGrid
                dataSource={mucPhaiThuChiTiets}
                columns={columns}
                height={window.innerHeight / 2 - 150}
                isLoading={false}
                keyExpr="id"
                paging={{
                    enable: false,
                }}
                selection={{
                    mode: 'multiple',
                    onSelectionChanged: setMucPhaiThuChiTietSelectedIds,
                    selectedRowKeys: mucPhaiThuChiTietSelectedIds,
                    isRowSelectionDisabled: (rowData: any) => (rowData.so_tien_da_nop || 0) <= Math.abs(rowData.so_tien_hoan_phi || 0)
                }}
                grouping={{
                    enable: true,
                    groupField: "ten_khoan_nop_group",
                    defaultExpanded: true
                }}
                focusedCell={{
                    focusedCell,
                    onFocusedCellChanged: setFocusedCell,
                }}
                totalSummary={totalSummary}
            />

            <Box sx={{ mt: 2 }}>
                {/* Lịch sử hoàn phí sẽ được hiển thị ở DataGrid bên dưới */}
            </Box>

            {isShowConfirmCreate && (
                <MyModal
                    isOpen={isShowConfirmCreate}
                    onClose={() => setIsShowConfirmCreate(false)}
                    title={translate("Xác nhận tạo hoàn phí")}
                    width={'400px'}
                >
                    <Box sx={{ p: 4, textAlign: 'center' }}>
                        <PrimerText sx={{ fontSize: 2, mb: 3, display: 'block' }}>
                            Bạn có chắc chắn muốn tạo chứng từ hoàn phí với tổng số tiền <b>{formatCurrency(totalHoanPhi)}</b>?
                        </PrimerText>
                    </Box>
                    <ModalActions>
                        <Button variant="default" onClick={() => setIsShowConfirmCreate(false)}>
                            {translate("Hủy bỏ")}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={hanldeCreateHoanPhiAsync}
                            isLoading={isSaving}
                        >
                            {translate("Xác nhận tạo")}
                        </Button>
                    </ModalActions>
                </MyModal>
            )}
            <DataGrid
                title="Danh sách chứng từ hoàn phí đã tạo"
                dataSource={existingRVVouchers}
                columns={rvColumns}
                height={250}
                isLoading={isLoadingExisting}
                keyExpr="id"
                filterRow={{
                    enable: true
                }}
            />
            {isShowRVChiTiet && rvSelected && (
                <ThuPhiChiTiet
                    sf_mucphaithu={rvSelected}
                    animationOf="right"
                    onClose={() => { setIsShowRVChiTiet(false); handleReloadAllAsync(); }}
                    ts_hocsinh={ts_hocsinh_viewmodel || {}}
                    nam_hoc={props.nam_hoc || ""}
                />
            )}
            {isShowRVHuy && rvSelected && (
                <HuyChungTuModal
                    sf_mucphaithu_id={rvSelected.id}
                    onClose={() => { setIsShowRVHuy(false); handleReloadAllAsync(); }}
                    onChanged={() => { setIsShowRVHuy(false); handleReloadAllAsync(); }}
                />
            )}
        </Box>
    );

    if (props.isTab) {
        return Content;
    }

    return (
        <MyModal
            isOpen={true}
            onClose={props.onClose}
            title={translate(`Hoàn phí học sinh`)}
            width="90%"
        >
            {Content}
            <ModalActions>
                <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: 'flex-end', pt: 2, borderTop: '1px solid', borderColor: 'border.default' }}>
                    <Button variant="default" onClick={props.onClose}>
                        {translate("Đóng")}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => setIsShowConfirmCreate(true)}
                        disabled={isSaving || mucPhaiThuChiTietSelectedIds.length === 0}
                    >
                        {`Tạo hoàn phí (${mucPhaiThuChiTietSelectedIds.length})`}
                    </Button>
                </Box>
            </ModalActions>
        </MyModal>
    );
};

export default HoanPhiHocSinhPage;
